<template>
  <div v-if="dataList.length">
    <!-- 缩小 -->
    <el-button
      size="mini"
      type="warning"
      v-if="miniNeedReviewLayout"
      class="magnify-mode"
      @click="miniMode(false)"
    >
      支付待审核订单<br />银行卡：{{
        needReviewOrderObj.bankNo || "-"
      }}</el-button
    >

    <!-- 展开 -->
    <div
      class="need-review-layout"
      v-else
      :style="`max-width: ${longWidthMode ? '1500px' : '310px'}`"
    >
      <!-- 操作项 -->
      <div style="cursor: pointer; font-size: 30px">
        <i
          @click="miniMode(true)"
          class="el-icon-minus"
          style="position: absolute; top: 15px; right: 15px"
        />
        <div style="position: absolute; top: 13px; right: 50px">
          <el-tooltip
            :content="longWidthMode ? '缩小窗口' : '放大窗口'"
            placement="bottom"
            effect="light"
          >
            <div v-if="!longWidthMode" @click="longWidthMode = true">
              <svg-icon icon-class="window-max" />
            </div>
            <div v-else @click="longWidthMode = false">
              <svg-icon icon-class="window-restore" />
            </div>
            <!-- <i
              v-if="!longWidthMode"
              class="el-icon-s-unfold"
              @click="longWidthMode = true"
            />
            <i v-else class="el-icon-s-fold" @click="longWidthMode = false" /> -->
          </el-tooltip>
        </div>
      </div>
      <!-- End 操作项 -->

      <div
        v-loading="submitLoading"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        element-loading-spinner="el-icon-loading"
      >
        <h4>
          支付待审核订单<br />
          <div style="margin-top: 10px">
            银行卡：{{ needReviewOrderObj.bankNo || "-" }}
          </div>
        </h4>

        <el-button
          @click="setDateRange(7)"
          :type="checkSelectedDate(7)"
          style="margin: 2px auto"
          size="mini"
          >一周</el-button
        >
        <el-button
          @click="setDateRange(14)"
          style="margin: 2px auto"
          size="mini"
          :type="checkSelectedDate(14)"
          >两周</el-button
        >
        <el-button
          @click="setDateRange(30)"
          style="margin: 2px auto"
          size="mini"
          :type="checkSelectedDate(30)"
          >一个月</el-button
        >

        <el-button
          :disabled="!selectedOrders.length"
          slot="reference"
          style="margin: 2px auto"
          size="mini"
          type="primary"
          @click="handleConfirmNeedReviewOrderObj('确定批量确认未收到吗？', 10)"
          >批量确认未收到</el-button
        >
        <el-button
          :disabled="!selectedOrders.length"
          slot="reference"
          style="margin: 2px auto"
          size="mini"
          type="success"
          @click="handleConfirmNeedReviewOrderObj('确定批量实际已收款吗？', 20)"
          >批量实际已收款</el-button
        >
        <el-button
          :disabled="!selectedOrders.length"
          slot="reference"
          style="margin: 2px auto"
          size="mini"
          type="warning"
          @click="
            handleConfirmNeedReviewOrderObj('确定批量无法确认转暂冻吗？', 15)
          "
          >批量无法确认转暂冻</el-button
        >
        <div class="table-layout">
          <el-table
            stripe
            :data="dataList"
            @selection-change="handleMutilSelection"
          >
            <el-table-column type="selection" width="42" align="center">
            </el-table-column>
            <el-table-column width="80" label="审核金额">
              <template slot-scope="scope">
                {{
                  formatNumberWithCommasAndDecimalSeparator(
                    scope.row.freezeCost,
                    2
                  )
                }}
              </template>
            </el-table-column>
            <el-table-column width="153" label="订单创建时间">
              <template slot-scope="scope">
                {{ scope.row.orderCreatedTime || "-" }}
              </template>
            </el-table-column>
            <el-table-column width="100" label="真实姓名">
              <template slot-scope="scope">
                {{ scope.row.realName || "-" }}
              </template>
            </el-table-column>
            <el-table-column
              width="200"
              prop="platformOrder"
              label="平台订单号"
            >
            </el-table-column>
            <el-table-column width="200" prop="appOrder" label="商户订单号">
            </el-table-column>
            <el-table-column
              v-if="longWidthMode"
              :fixed="checkFixed"
              align="center"
              width="210"
              label="操作"
            >
              <template slot-scope="scope">
                <el-button
                  slot="reference"
                  style="margin: 2px auto"
                  size="mini"
                  type="primary"
                  @click="
                    handleConfirmNeedReviewOrderObj(
                      '确定确认未收到吗？',
                      10,
                      scope.row
                    )
                  "
                  >确认未收到</el-button
                >
                <el-button
                  slot="reference"
                  style="margin: 2px auto"
                  size="mini"
                  type="success"
                  @click="
                    handleConfirmNeedReviewOrderObj(
                      '确定实际已收款吗？',
                      20,
                      scope.row
                    )
                  "
                  >实际已收款</el-button
                >
                <el-button
                  slot="reference"
                  style="margin: 2px auto"
                  size="mini"
                  type="warning"
                  @click="
                    handleConfirmNeedReviewOrderObj(
                      '确定无法确认转暂冻吗？',
                      15,
                      scope.row
                    )
                  "
                  >无法确认转暂冻</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery.pageNum"
          :limit.sync="listQuery.pageSize"
          @pagination="getList()"
        />

        <el-alert type="warning" :closable="false" style="margin-bottom: 20px">
          此列表为卡主收款失败并未审核的收款订单，请根据卡主提供的视频判断这些订单是否真的没有收到。
        </el-alert>
      </div>
      <el-dialog
        top="20vh"
        width="300px"
        center
        :close-on-click-modal="false"
        :visible="confirmNeedReviewOrderObj.visible"
        @close="confirmNeedReviewOrderObj.visible = false"
        :title="`${confirmNeedReviewOrderObj.title || '-'}`"
      >
        <div style="text-align: center">
          <el-button
            size="mini"
            round
            @click="confirmNeedReviewOrderObj.visible = false"
          >
            取消
          </el-button>
          <el-button
            size="mini"
            :loading="submitLoading"
            round
            type="success"
            @click="submitConfirmNeedReviewOrderObj()"
          >
            保存
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import varCommon from "@/utils/varCommon";
import Pagination from "@/views/components/Pagination";
import {
  needReviewOrders, // 审核支付单列表
  reviewPayOrders, // 确认审核状态与视频关连
} from "@/api/order";

export default {
  mixins: [mainCommon],
  props: ["needReviewOrderObj"],
  components: { Pagination },
  data() {
    return {
      submitLoading: false,
      dataList: [],
      total: 0,
      listQuery: {
        pageSize: varCommon.pagination.pageSize,
        pageNum: 1,
        status: 1,
        bankNo: null,
        platformOrder: null,
        appOrder: null,
        username: null,
        accID: null,
      },
      selectedOrders: [], // 批量订单选取
      reviewReason: 10, // 所选审核状态
      longWidthMode: false, // 改变弹框宽度
      miniNeedReviewLayout: false, // 迷你化弹框
      confirmNeedReviewOrderObj: {
        visible: false,
        title: null,
        row: null,
        reviewStatus: null,
      },
    };
  },
  created() {
    if (this.needReviewOrderObj) {
      this.setDateRange();
    }
  },
  watch: {
    needReviewOrderObj(row) {
      if (row) {
        this.setDateRange();
      } else {
        // 清空列表
        this.dataList = [];
      }
    },
  },
  methods: {
    // 当前选择天数
    checkSelectedDate(day) {
      let start = new Date();
      start.setDate(start.getDate() - day);
      start.setHours(0, 0, 0, 0);

      if (
        this.listQuery.beginOrderCreatedTime === this.HandleDateYMDFormat(start)
      ) {
        return "success";
      }
    },
    // 设置日期区间
    setDateRange(day) {
      let start = new Date();
      start.setDate(start.getDate() - (day || 7));
      start.setHours(0, 0, 0, 0);

      let end = new Date();
      end.setHours(23, 59, 59, 999);

      this.listQuery.beginOrderCreatedTime = this.HandleDateYMDFormat(start);
      this.listQuery.endOrderCreatedTime = this.HandleDateYMDFormat(end);

      this.listQuery.bankNo = this.needReviewOrderObj.bankNo;
      this.listQuery.accID = this.needReviewOrderObj.accId;
      this.getList();
    },
    // 缩小化
    miniMode(bool) {
      this.miniNeedReviewLayout = bool;
    },
    handleConfirmNeedReviewOrderObj(title, reviewStatus, row) {
      this.confirmNeedReviewOrderObj = {
        visible: true,
        title,
        row: row || null,
        reviewStatus,
      };
    },
    submitConfirmNeedReviewOrderObj() {
      console.log(this.confirmNeedReviewOrderObj.row);
      if (this.confirmNeedReviewOrderObj.row) {
        // 单独审核订单
        this.reviewPayOrders([
          {
            reviewId: this.confirmNeedReviewOrderObj.row.id,
            reviewStatus: this.confirmNeedReviewOrderObj.reviewStatus, // 审核状态 1:审核中, 10:确认未收到, 20:实际已收款, 15:无法确认转暂冻
            orderId: this.confirmNeedReviewOrderObj.row.orderId,
          },
        ]);
      } else {
        // 批量审核订单
        const reviewOrders = this.selectedOrders.map((res) => {
          return {
            reviewId: res.id,
            reviewStatus: this.confirmNeedReviewOrderObj.reviewStatus, // 审核状态 1:审核中, 10:确认未收到, 20:实际已收款, 15:无法确认转暂冻
            orderId: res.orderId,
          };
        });
        this.reviewPayOrders(reviewOrders);
      }
    },
    reviewPayOrders(reviewOrders) {
      this.submitLoading = true;
      reviewPayOrders({
        accId: this.needReviewOrderObj.accId,
        mediaId: this.needReviewOrderObj.id,
        mediaPath: this.needReviewOrderObj.url,
        withdrawPKOrderId: this.needReviewOrderObj.withdrawPKOrderId,
        reviewOrders,
      })
        .then((res) => {
          this.$notify.success(res.message);
          this.getList();
        })
        .finally(() => {
          this.submitLoading = false;
          this.confirmNeedReviewOrderObj = {
            visible: false,
            title: null,
            row: null,
            reviewStatus: null,
          };
        });
    },
    handleMutilSelection(row) {
      this.selectedOrders = row;
    },
    getList() {
      this.submitLoading = true;
      needReviewOrders(this.ObjectClean(this.listQuery))
        .then((res) => {
          this.dataList = res.data.list;
          this.total = res.data.total;
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.magnify-mode {
  position: fixed;
  left: 1vw;
  top: 2vh;
  z-index: 20000;
  padding: 20px 40px;
  border-radius: 10px;
}
.need-review-layout {
  background-color: #fff;
  position: fixed;
  left: 1vw;
  top: 2vh;
  z-index: 20000;
  padding: 0 20px;
  box-shadow: 0px 0px 5px 0px #666;
  border-radius: 10px;
  transition: all 0.5s;
  .el-icon-s-unfold,
  .el-icon-s-fold {
    float: right;
    cursor: pointer;
    color: #909399;
  }
  .table-layout {
    overflow-y: auto;
    min-height: 50px;
    max-height: 450px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/components/NeedReviewOrder.vue